import React from 'react';
import './styles.scss';

export interface IArgs {
    handlerChange?: Function;
    handlerIcon?: Function;
    handlerBlur?: Function;
    labelName?: string;
    type: string;
    name: string;
    icon?: string;
    value: string | number;
    asErrors?: string;
    asTouched?: boolean;
    asSubmitError?: string;
    size?: number;
    maxlength?: number;
    reference?: any;
    description?: string;
    handleKeyPress?: Function;
    onPaste?: Function;
    disabled?: boolean;
    prefix?: string;
    sufix?: string;
    min?: number;
    max?: number;
    autoComplete?: string;
    pattern?: string;
    customClass?: string;
}

const Input = ({
    handlerChange,
    handlerIcon,
    handlerBlur,
    labelName,
    type,
    name,
    icon = '',
    value,
    asErrors,
    asTouched,
    asSubmitError,
    size = 20,
    maxlength = 524288,
    reference,
    description,
    handleKeyPress,
    disabled = false,
    prefix,
    sufix,
    onPaste,
    min,
    max,
    autoComplete,
    pattern,
    customClass = '',
}: IArgs) => {
    return (
        <div className={`c-form-field  u-mb-large u-mt-large ${customClass}`}>
            <label htmlFor='lcahjdne' className='c-form-field__label'>
                {labelName}
            </label>
            <div className='c-form-field__box'>
                <div className='c-input  '>
                    <span className='input-prefix'>{prefix}</span>
                    <input
                        className={`c-input__input ${
                            asErrors && asTouched ? 'is-error' : ''
                        }`}
                        name={name}
                        value={value}
                        type={type}
                        placeholder=''
                        data-tr-component='Input Field'
                        data-tr-function='Text Input'
                        onBlur={(event) => {
                            if (handlerBlur) handlerBlur(event);
                        }}
                        onChange={(event) => {
                            if (handlerChange) handlerChange(event);
                        }}
                        size={size}
                        maxLength={maxlength}
                        ref={reference}
                        onKeyDown={(event) => {
                            if (handleKeyPress) handleKeyPress(event);
                        }}
                        disabled={disabled}
                        onPaste={(event) => {
                            if (onPaste) onPaste(event);
                        }}
                        min={min}
                        max={max}
                        autoComplete={autoComplete}
                        pattern={pattern}
                        style={{
                            borderWidth: 0,
                            borderBottomWidth: '1px',
                        }}
                    />
                    <span className='input-prefix'>{sufix}</span>
                    {icon !== '' && (
                        <span className='c-input__addon'>
                            <i
                                onClick={() => {
                                    if (handlerIcon) handlerIcon();
                                }}
                                className={`c-icon c-icon--[${icon}]`}
                                aria-hidden='true'
                                role='img'
                            >
                                <></>
                            </i>
                        </span>
                    )}
                </div>
                <div>
                    {asErrors && asTouched && (
                        <span
                            className={'c-error-message'}
                            style={{ position: 'absolute' }}
                        >
                            {asErrors}
                        </span>
                    )}
                    {asSubmitError && !(asErrors && asTouched) && (
                        <span
                            className={'c-error-message'}
                            style={{ position: 'absolute' }}
                        >
                            {asSubmitError}
                        </span>
                    )}
                    {description && (
                        <span
                            className={'c-input-description'}
                            dangerouslySetInnerHTML={{
                                __html: description,
                            }}
                        ></span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Input;
